import { render, staticRenderFns } from "./reviewer_avatar_link.vue?vue&type=template&id=5e633b9a"
import script from "./reviewer_avatar_link.vue?vue&type=script&lang=js"
export * from "./reviewer_avatar_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports